import { render, staticRenderFns } from "./OrderErpIntegrationPopup.vue?vue&type=template&id=fcaad7a6&"
import script from "./OrderErpIntegrationPopup.vue?vue&type=script&lang=js&"
export * from "./OrderErpIntegrationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports